(function ($) {
  $(document).on('facetwp-loaded', () => {
    const inUse = (FWP.buildQueryString() !== '');
    $('.vtc_active_filters').toggleClass('hidden', !inUse);
  });
}(jQuery));
